import reviewMusicUrl from '../../../assets/review/review-music.mp3';
import reviewChimeUrl from '../../../assets/review/review-chime.mp3';
import { getMapAmbientAudio } from './mapAmbientMusic';

export const REVIEW_MUSIC_VOLUME = 0.6;
const REVIEW_CHIME_VOLUME = 0.35;

let music = null;
let chime = null;
let muted = false;

function getMusic() {
  if (!music) {
    music = new Audio(reviewMusicUrl);
    music.loop = true;
    music.preload = 'auto';
    music.volume = REVIEW_MUSIC_VOLUME;
  }
  return music;
}

export function preloadReviewAudio() {
  try {
    getMusic().load();
    if (!chime) {
      chime = new Audio(reviewChimeUrl);
      chime.preload = 'auto';
      chime.volume = REVIEW_CHIME_VOLUME;
    }
  } catch {
    // Sin audio el review sigue funcionando.
  }
}

// Debe llamarse dentro de un gesto del jugador (botón "Ver mi review").
export function startReviewMusic() {
  try {
    getMapAmbientAudio().pause();
    const audio = getMusic();
    audio.muted = muted;
    audio.currentTime = 0;
    const attempt = audio.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
  } catch {
    // Autoplay bloqueado o sin audio: el review continúa en silencio.
  }
}

export function stopReviewMusic() {
  try {
    if (music) music.pause();
    if (chime) chime.pause();
  } catch {
    // Nada que detener.
  }
}

export function setReviewMuted(next) {
  muted = Boolean(next);
  if (music) music.muted = muted;
  if (chime) chime.muted = muted;
}

export function playReviewChime() {
  try {
    if (!chime || muted) return;
    chime.currentTime = 0;
    const attempt = chime.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
  } catch {
    // Efecto opcional.
  }
}
